import type { SchedulerSnapshotRecord } from '../services/schedulerSnapshotStore';
import { webSnapshotRepository } from '../../platform/web/schedulerSnapshotRepository';

// Raw storage only: scope trust, authority leases, TTLs and hot-tier identity
// remain in schedulerSnapshotStore. A stored candidate never grants authority.
export interface SnapshotRepository {
  read(key: string): Promise<SchedulerSnapshotRecord | null>;
  write(record: SchedulerSnapshotRecord): Promise<void>;
  delete(key: string): Promise<void>;
  removeWhere(matches: (record: SchedulerSnapshotRecord) => boolean): Promise<void>;
  durability(): 'memory' | 'persistent';
  resetMemory(): void;
}
export const schedulerSnapshotRepository: SnapshotRepository = webSnapshotRepository;
